import { GoBackController } from './go-back.controller'

function goBackDirective () {
  return {
    restrict: 'E',
    scope: {
      text: '@',
      // Use 'onClick' to pass a function
      onClick: '=',
      // Use 'state' to pass a state. ex: 'workflow.home'
      state: '@'
    },
    templateUrl: '/workflow/directives/go-back/go-back-directive.html?$$REVISION$$',
    controller: GoBackController
  }
}

export { goBackDirective }
